export default __webpack_public_path__ + "static/media/btg-mono.65ca21a3.svg";